<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span>选择支付方式</span>
        <span>购买成功开通权限</span>
      </div>
      <div class="mod orderInfo">
        <h3 class="title">订单详情<span>{{remark}}</span></h3>
        <ul class="column6">
          <li class="title">
            <div class="liwrap">
              <div>产品名称</div>
              <div>价格/年限</div>
              <div class="child3">数量</div>
              <div class="child4">有效期</div>
              <div class="child5">优惠</div>
              <div class="child6">实付</div>
            </div>
          </li>
          <li class="mainli">
            <div class="liwrap">
              <div>
                <p>{{ product.name }}</p>
                <p class="giftName" v-show="productId !== null">{{ product.describe }}</p>
              </div>
              <div class="select">
                <el-select v-model="month" placeholder="请选择" style="width:150px">
                  <el-option
                    v-for="item in product.productPriceVos"
                    :key="item.month"
                    :label="item.oriPrice | formatMonth(item.month)"
                    :value="item.month"
                  ></el-option>
                </el-select>
              </div>
              <div class="child3">*{{month | formatQuantity}}</div>
              <div
                v-for="item in product.productPriceVos"
                :key="item.month"
                v-show="item.month === month"
                class="child4"
              >{{item.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{item.powerEndDt | dateFormat("yyyy-MM-dd")}}</div>
              <div class="child5">¥ {{mainCurPrice | twinPointAmountFormat(mainOriPrice)}}</div>
              <div class="child6">¥ {{mainCurPrice}}</div>
            </div>
          </li>
          <template v-for="item in product.productPriceVos">
            <li :key="item.month" v-show="item.month === month && item.subProductPriceVos" class="subli">
              <div v-for="subItem in item.subProductPriceVos" :key="subItem.month" class="liwrap">
                <div>{{subItem.productName}}</div>
                <div>{{subItem.oriPrice | formatMonth(subItem.month)}}</div>
                <div class="child3">*{{subItem.month}}个月</div>
                <div class="child4">{{subItem.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{subItem.powerEndDt | dateFormat("yyyy-MM-dd")}}</div>
                <div class="child5">¥ {{subItem.curPrice | amountUnitFormat(subItem.oriPrice)}}</div>
                <div class="child6">¥ {{subItem.curPrice}}</div>
              </div>
            </li>
          </template>
        </ul>
        <div class="totalLine">
          <p class="note" v-show="month === 1">*该月卡为特惠体验产品，仅可购买一次，且不支持折换等其他优惠活动，敬请谅解</p>
          <p class="note" v-show="month === 7 || month === 14">*该周卡/双周卡为特惠体验产品，仅可选择其一购买一次，且不支持折换等其他优惠活动，敬请谅解</p>
          <div class="subtotal">
            <div>小计</div>
            <div>共{{productNum}}件</div>
            <div>¥ {{mainCurPrice | getDisCountMoney(mainOriPrice,subCurPrice,subOriPrice,convertMoneyEnd)}}</div>
            <div>¥ {{ mainCurPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd) }}</div>
          </div>
          <div class="discount-money">
            <div class="note-r">
              <p>
                <span>{{this.discountIndex === 1 ? '已折算：' : '已优惠：'}}</span>
                <em
                  v-for="item in product.productPriceVos"
                  :key="item.month"
                  v-show="item.month === month"
                >{{mainCurPrice | getDisCountMoney(mainOriPrice,subCurPrice,subOriPrice,convertMoneyEnd)}} 元</em>
              </p>
              <p class="totalMoney">
                <span>支付金额总计：</span>
                <strong
                  v-for="item in product.productPriceVos"
                  :key="item.month"
                  v-show="item.month === month"
                >{{ mainCurPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd)}}</strong>
                <em>元</em>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 购买协议组件 -->
      <div class="license">
        <h3 class="title">
          <span class="agreement">
            <router-link to="/protocol" target="_blank">使用软件产品许可协议</router-link>
          </span>
          <p>
            <i
              class="icon-right"
              @click="cancelActive = !cancelActive"
              :class="{cancel:cancelActive}"
            ></i>我已仔细阅读相关协议，对其内容表示确认
          </p>
        </h3>
      </div>
      <div class="mod invoice">
        <h3 class="title">发票信息</h3>
        <p>
          <strong>
            <span>电子普通发票</span>
            <span v-show="invoiceTitleType == 1">个人</span>
            <span v-show="invoiceTitleType == 2">单位</span>
            <span>信息技术服务</span>
          </strong>
          <em class="modify" @click="openInvoice">发票填开</em>
        </p>
        <a class="confirmBtn" @click="orderConfirm">确认订单</a>
        <!-- 电子发票组件 -->
        <invoice @changeInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
      </div>
    </div>
    <app-footer />
    <bind-tel :info="info" v-show="isPop" @close="popColse"></bind-tel>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import Protocol from "@/components/protocol/Protocol.vue";
import Invoice from "@/components/invoice/Invoice.vue";
// import PayFinsh from '../client/PayFinsh.vue';
import BindTel from '@/components/product/BindTel.vue'

export default {
  data() {
    return {
      product: {},
      productId: 335,
      month: '',
      cancelActive: false,
      invoiceTitleType: 1,
      discountList: [],
      discountText: false,
      convertMoney: 0,
      remark:'',
      voucherCode:0,
      voucherMsg:"",
      info: {
        isWait: true,
        isBind: true,
        bindUrl: ''
      },
      isPop: false,
      isShowMore: false,
      discountIndex:2,
      oyb: false,
      yjtText: false,
      dateUnit: '', // 单位
      showAll: 0,
      s: this.$route.query.s
    };
  },
  created() {
    var month = this.$route.params.month;
    if (month === '1m') {
      this.month = 1
    } else if (month === '7d') {
      this.month = 7
    } else if (month === '14d') {
      this.month = 14
      this.productClick()
    }
    document.title="大智慧股票软件网上商城"
    this.getProduct();
  },
  mounted() {
    this.invoiceTitleType = this.$refs.invoice.invoiceTitleType;
  },

  computed: {
    curPrice() {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          return item.curPrice;
        }
      });
    },
    oriPrice() {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          return item.oriPrice;
        }
      });
    },
    activityType() {
      let type = '' ;
      this.product.productPriceVos.forEach(item =>{
        if(item.month == this.month) {
           type= item.activityType
        }
      })
      return type;
    },
    convertMoneyEnd () {
      return this.discountIndex === 1 ? this.convertMoney : 0
    },
    orderType () {
      return this.discountIndex === 1 ? 1 : 0
    }
  },
  watch: {
    month () {
      if (this.product.productPriceVos) {
        this.getPrice()
      }
    }
  },
  methods: {
    getProduct() {
      if (this.month === 7 || this.month === 14) {
        this.$router.push('/404')
      }
      var params = {
        id: this.productId,
        showAll: this.showAll
      };
      if (this.month) {
        params.month = this.month
      }
      this.$get("/product/day_detail", params)
        .then(response => {
          if (response.code === 0) {
            this.product = response.data;
            if(response.data.month === 1){
              this.oyb = true;
            }
            var prices = this.product.productPriceVos;
            this.dateUnit = this.product.productPriceVos[0].dateUnit
            this.getPrice()
            var flag = false;
            if (this.month) {
              prices.forEach((item, index) => {
                if (item.month == this.month) {
                  flag = true;
                  if(item.remark){this.remark = item.remark}
                }
              });
              if (!flag) {
                this.month = prices[0].month;
              }
            } else {
              this.month = prices[0].month;
            }
            // this.$get("/order/orderUpgradeCalc", params)
            //   .then(response => {
            //     if (response.code === 0) {
            //       this.discountList = response.data;
            //       this.discountList.length > 0 && (this.discountText = true);
            //       this.convertMoney = this.discountList.reduce((pre, cur) =>{
            //         return pre + cur.convertMoney
            //       }, 0)
            //     } else {
            //       this.voucherCode = response.code;
            //       this.voucherMsg = response.msg
            //       return
            //     }
            //   })
          }else if(response.code === 107){
            this.$global.alertAndGoHistory(response.msg)
          }
           else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
    },
    orderConfirm() {
      if (this.cancelActive) {
        this.$alert(
          "请仔细阅读“上海大智慧信息科技有限公司软件产品许可使用协议”，阅读结束后同意请选中“我同意协议”钩选框，然后继续购买。",
          "提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }
      // 保存订单并跳转到支付页面
      var params = {
        productId: this.productId,
        monthCount: this.month,
        invoiceTitleType: this.invoiceTitleType,
        orderType: this.orderType,
        convertMoney: this.convertMoneyEnd,
        activityType: this.activityType,
        dateUnit: this.dateUnit,
        buySource: this.s,
        questionsId: "0"
      };
      if (Number(this.productId) === 335) {
        this.isPop = true
        this.$get('user/checkMobile?'+"productId="+this.productId+"&month="+this.month).then(res =>{
          if(res.code === 0) {
            this.isPop = false
            this.$post("/order/save", params)
            .then(response => {
              if (response.code === 0) {
                this.$router.push("/order/pay/" + response.data.id);
              } else if (response.code != 100) {
                this.$global.alert(response.msg);
              }
            })
            .catch(err => {
              this.$global.alertError();
            });
          } else if(res.code === 107) {
            this.info.isWait = false
            this.info.isBind = false
            this.info.bindUrl = res.msg
          } else {
              this.$global.alert(res.msg);
            }
        }).catch(err => {
          this.$global.alertError();
        });
      } else {
        this.$post("/order/save", params)
        .then(response => {
          if (response.code === 0) {
            this.$router.push("/order/pay/" + response.data.id);
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
      }
    },
    changeSelect (i) {
      this.curIndex = i
    },
    getPrice () {
      this.product.productPriceVos.forEach(item => {
        if (item.month == this.month) {
          this.mainCurPrice = item.curPrice;
          this.mainOriPrice = item.oriPrice
          if (item.hasOwnProperty("subProductPriceVos")) {
            this.subCurPrice = item.subProductPriceVos.reduce((pre, cur) =>{
              return pre + cur.curPrice
            }, 0)
            this.subOriPrice = item.subProductPriceVos.reduce((pre, cur) =>{
              return pre + cur.oriPrice
            }, 0)
            this.productNum = 1 + item.subProductPriceVos.length
          } else {
            this.subCurPrice = 0
            this.subOriPrice = 0
            this.productNum = 1
          }
        }
      })
      if(this.productId === '335' && (this.month === 1 || this.month === 7 || this.month === 14)){
          this.yjtText = true;
      }else{
        this.yjtText = false;
      }
    },
    popColse (val) {
      this.isPop = val
    },
    // 335双周卡统计
    productClick () {
      var params =  {
        id : 335,
        num:  14,
        dateUnit: 'day',
        source: 'pc_baidu'
      }
      var userName = this.$storage.getUserName()
      if (!userName) return
      this.$post('/product/productClick', params)
        .then(res =>{
          // console.log(res)
        })
    },
  },
  filters: {
    formatMonth (price, month) {
      if (month === 1) {
        return price + '元/' + month + '月'
      } else if (month === 7) {
        return price + '元/7天'
      } else if (month === 14) {
        return price + '元/14天'
      }
    },
    formatQuantity (month) {
      if (month === 1) {
        return month + '个月'
      } else if (month === 7) {
        return '7天'
      } else if (month === 14) {
        return '14天'
      }
    }
  },
  components: {
    AppHeader,
    AppFooter,
    Protocol,
    Invoice,
    BindTel
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.totalLine {
  overflow: hidden;
  color: #666;
}
.totalLine .note {
  font-size: 16px;
  // float: left;
  margin: 0px 0 20px 0px;
}
.totalLine .note-r {
  float: right;
  font-size: 16px;
}
.totalLine .note-r p {
  margin-bottom: 10px;
}
.totalLine .note-r p span {
  margin-right: 5px;
}
.totalLine .note-r p:nth-child(1) span {
  float: left;
}
.totalLine .note-r p:nth-child(1) em {
  display: block;
  text-align: right;
}
.totalLine .totalMoney strong {
  font-size: 30px;
  color: #EF3939;
}
.totalLine .totalMoney em {
  font-size: 18px;
  color: #EF3939;
}
.invoice .title + p span {
  margin-right: 20px;
}
.orderWrap .invoice {
  position: relative;
  padding-bottom: 50px;
}
.invoice .modify {
  color: #166fff;
  cursor: pointer;
  font-size: 20px;
  background: rgba(22,111,255,0.05);
  border: 1px solid rgba(22,111,255,0.30);
  border-radius: 2px;
  float: left;
  margin-left: 20px;
  line-height: 42px;
  width: 100px;
  text-align: center;
}
.invoice .confirmBtn {
  position: absolute;
  top: 80px;
  right: 100px;
  background: #166fff;
  border-radius: 4px;
  width: 163px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  color: #fff;
  display: block;
}
.invoice .confirmBtn:hover {
  background: #1460db;
}
.invoice .title + p {
  padding-left: 35px;
}
.totalLine .voucherText {
  // padding-left: 35px;
}
.totalLine .moreText {
  // float: right;
  text-align:right;
  a{
    font-size: 16px;color:#286DF7;
    &:after{
      content:'';display:inline-block;margin:0 10px;vertical-align:2px;
      width:10px;height:10px;border-bottom:1px solid #999;border-right:1px solid #999;transform:rotate(45deg);
    }
  }
  &.up a:after{
    transform:rotate(225deg);vertical-align:-4px;
  }
}
.invoice .title + p {
  overflow: hidden;
}
.invoice .title + p > strong{
  background: rgba(22,111,255,0.05);
  border: 1px dashed rgba(22,111,255,0.30);
  line-height: 42px;
  padding-left: 20px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  float: left;
  // &:after{
  //   content: '';
  //   position: absolute;
  //   right: -8px;
  //   top: 12px;
  //   background: #fff;
  //   border: 1px dashed rgba(22,111,255,0.30);
  //   width: 15px;
  //   height: 15px;
  //   border-radius: 50%;
  //   z-index: 10;
  // }
}
.discount-select{
  float:none;padding:15px 10px;background:#F8F8F8;border:1px solid #E9E9E9;margin-top:15px;
  div{
    margin:0;
  }
  .discount-text{
    margin:0;
    p{margin-bottom:15px;}
  }
  .select-item{
    margin-right:50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderConfirm335.vue